import React, { useEffect } from 'react';
import ContensisUserManager, {
  userManager,
} from './helpers/user/ContensisUserManager';

const SignInCallback = () => {
  const token = ContensisUserManager.HasSecurityTokenQueryString() as string;
  useEffect(() => {
    if (token) userManager.SsoPopupCallback();
  }, [token]);

  return (
    <div
      style={{
        width: '100%',
        height: '1000px',
        background: 'white',
        padding: '20px',
        overflow: 'hidden',
      }}
    >
      {token && (
        <p>
          You are about to complete sign in. Please do not close this window
        </p>
      )}
      {!token && (
        <p style={{ color: 'red' }}>
          The required security token has not been supplied
        </p>
      )}
    </div>
  );
};

export default SignInCallback;
